import React from 'react';
import Card from '../components/Card';
import contactImg from '../utils/images/contact.png';
import {
    faGithub,
    faLinkedin,
    faQuora,
    faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Contact = () => {
    return (
        <Card icon="📞" title="CONTACT ME!" image={contactImg}>
            <div className="pt-4 text-lg text-left lg:pt-6">
                <p>
                    You can find me active on{' '}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://discordapp.com/users/616544073595224074"
                        style={{ borderBottomWidth: 0.5 }}
                        className="transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        Discord
                    </a>
                    !
                </p>
                <p className="mt-2">
                    Feel free to drop an E-Mail at{' '}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="mailto:satej.bidvai@gmail.com"
                        style={{ borderBottomWidth: 0.5 }}
                        className="transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        satej.bidvai@gmail.com
                    </a>
                    !
                </p>
            </div>

            <div className="flex items-center justify-start w-full mt-10 space-x-5">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://github.com/satejbidvai"
                    className="flex items-center justify-center w-12 h-12 transition duration-300 ease-in-out border-2 rounded-full hover:bg-white hover:bg-opacity-25"
                >
                    <FontAwesomeIcon icon={faGithub} size="lg" />
                </a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/in/satej-bidvai-9a18b3193/"
                    className="flex items-center justify-center w-12 h-12 transition duration-300 ease-in-out border-2 rounded-full hover:bg-white hover:bg-opacity-25"
                >
                    <FontAwesomeIcon icon={faLinkedin} size="lg" />
                </a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.quora.com/profile/Satej-Bidvai"
                    className="flex items-center justify-center w-12 h-12 transition duration-300 ease-in-out border-2 rounded-full hover:bg-white hover:bg-opacity-25"
                >
                    <FontAwesomeIcon icon={faQuora} size="lg" />
                </a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/satejbidvai/"
                    className="flex items-center justify-center w-12 h-12 transition duration-300 ease-in-out border-2 rounded-full hover:bg-white hover:bg-opacity-25"
                >
                    <FontAwesomeIcon icon={faInstagram} size="lg" />
                </a>
            </div>
        </Card>
    );
};

export default Contact;
